import React from 'react';
import { motion } from 'framer-motion';
import { FileCheckIcon, SearchIcon, KeyIcon } from 'lucide-react';
export function ProcessSection() {
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 30
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      margin: '-50px'
    },
    transition: {
      duration: 0.5
    }
  };
  return <section className="w-full bg-[#1B3A5C] py-16 md:py-24 px-4" data-id="element-139">
      <div className="max-w-5xl mx-auto" data-id="element-140">
        <motion.h2 {...fadeInUp} className="text-2xl md:text-3xl font-extrabold text-white text-center mb-12" data-id="element-141">
          Cómo Funciona
        </motion.h2>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-142">
          <motion.div {...fadeInUp} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-center" data-id="element-143">
            <div className="w-16 h-16 bg-[#D4A843] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-144">
              <span className="text-3xl font-extrabold text-[#1B3A5C]" data-id="element-145">1</span>
            </div>
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-146">
              <FileCheckIcon className="w-6 h-6 text-[#D4A843]" data-id="element-147" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-148">
              Prepara tu Perfil
            </h3>
            <p className="text-white/70" data-id="element-149">
              Sigue el plan para limpiar tu crédito y organizar tus papeles en
              30 días.
            </p>
          </motion.div>

          <motion.div {...fadeInUp} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-center" data-id="element-150">
            <div className="w-16 h-16 bg-[#D4A843] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-151">
              <span className="text-3xl font-extrabold text-[#1B3A5C]" data-id="element-152">2</span>
            </div>
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-153">
              <SearchIcon className="w-6 h-6 text-[#D4A843]" data-id="element-154" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-155">
              Localiza el Dinero
            </h3>
            <p className="text-white/70" data-id="element-156">
              Identifica qué programa de asistencia en tu ciudad pagará tu
              enganche.
            </p>
          </motion.div>

          <motion.div {...fadeInUp} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-center" data-id="element-157">
            <div className="w-16 h-16 bg-[#D4A843] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-158">
              <span className="text-3xl font-extrabold text-[#1B3A5C]" data-id="element-159">3</span>
            </div>
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-160">
              <KeyIcon className="w-6 h-6 text-[#D4A843]" data-id="element-161" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-162">
              Cierra el Trato
            </h3>
            <p className="text-white/70" data-id="element-163">
              Encuentra la casa, aplica el "apilamiento" y recibe tus llaves en
              90 días o menos.
            </p>
          </motion.div>
        </div>

        {/* Proof Section */}
        <motion.div {...fadeInUp} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/20" data-id="element-164">
          <h3 className="text-xl font-bold text-[#D4A843] mb-4" data-id="element-165">
            Lo que cambia en 7 días:
          </h3>
          <p className="text-white/90 text-lg leading-relaxed" data-id="element-166">
            Dejarás de mirar listas de casas con frustración y sabrás
            exactamente para qué precio calificas y cuánto dinero del gobierno
            está esperando por ti. No más adivinanzas, solo un plan financiero
            sólido.
          </p>
        </motion.div>
      </div>
    </section>;
}